import { render } from "./AddGreenHousePlant.vue?vue&type=template&id=43b51ccc"
import script from "./AddGreenHousePlant.vue?vue&type=script&lang=js"
export * from "./AddGreenHousePlant.vue?vue&type=script&lang=js"

import "./AddGreenHousePlant.vue?vue&type=style&index=0&id=43b51ccc&lang=scss"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__